class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#ajaxcart-overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }
   setHeaderCartIconAccessibility() {
      const cartLink = document.querySelectorAll('#ajax-cart-icon, #ajax-cart-icon-redesign');
      for (var i = 0; i < cartLink.length; i++){
         cartLink[i].setAttribute('role', 'button');
         cartLink[i].setAttribute('aria-haspopup', 'dialog');
          cartLink[i].addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink)
          });
  
         cartLink[i].addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
              event.preventDefault();
              this.open(cartLink[i]);
            }
          });
      }
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".cart-inner-empty")
          : document.getElementById("ajaxcart");
        const focusElement = this.querySelector(".drawer-inner");
        triggerClick(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }
  close() {
    this.classList.remove("active");
    triggerClickClose(this.activeElement);
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.parentElement.addEventListener("keyup", escClick);
  }
  renderContents(parsedState) {
    
    this.querySelector('.drawer-inner').classList.contains('is-empty') && this.querySelector('.drawer-inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    
    var parsedCount = new DOMParser().parseFromString(parsedState.sections['ajax-cart-icon'], 'text/html');
    var resultCount = parsedCount.querySelector(".bigcounter").innerHTML;
    //console.log(parsedCount);
   
    var counterEls = document.querySelectorAll('#ajax-cart-icon-redesign, #ajax-cart-icon');
    counterEls.forEach((element) => {
        element.querySelector('.bigcounter').innerHTML = resultCount;
    });

    this.fetchSecToInclude().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      console.log(sectionElement);
      sectionElement.innerHTML = this.callSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    
    setTimeout(() => {
      this.querySelector('#ajaxcart-overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  callSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  fetchSecToInclude() {
    return [
      {
        id: "ajax-cart",
        selector: "#ajaxcart",
      },
      {
        id: "ajax-cart-icon",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("ajax-cart", ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: "ajaxcart",
        section: "ajax-cart",
        selector: ".drawer-inner",
      },
      {
        id: "ajax-cart-icon",
        section: "ajax-cart-icon",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-pro", ajaxCartPro);
